import script from "./externally-mapped-icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./externally-mapped-icon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__